'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import type { CSSProperties } from 'react';
import { Image } from 'react-datocms';
import { Heading } from '~/components/Heading';
import { Box } from '~/components/Layout/Box';
import { Stack } from '~/components/Layout/Stack';
import { Section } from '~/components/marketing/Section';
import type { Locale } from '~/i18n/i18n-config';
import { api } from '~/libs/api';
import { ReusableNewsletterForm } from './ReusableNewsletterForm';
import styles from './ReusableNewsletterSignup.module.css';
import type { ReusableNewsletterFormValues, ReusableNewsletterSignupProps } from './ReusableNewsletterSignup.types';
const ReusableNewsletterSignup = t0 => {
  const $ = _c(23);
  const {
    data,
    source
  } = t0;
  const {
    img,
    heading,
    description,
    departureDatePrompt
  } = data;
  const hideDepartureDate = data.hideDepartureDate === true;
  const locale = useLocale() as Locale;
  const newsletterSignup = api.automation.newsletterSignup.useMutation();
  const diyNewsletterSignup = api.automation.diyNewsletterSignup.useMutation();
  let t1;
  if ($[0] !== diyNewsletterSignup || $[1] !== hideDepartureDate || $[2] !== locale || $[3] !== newsletterSignup) {
    t1 = values => hideDepartureDate ? newsletterSignup.mutateAsync({
      emailAddress: values.email,
      sourcePage: values.source,
      locale
    }) : diyNewsletterSignup.mutateAsync({
      emailAddress: values.email,
      departureDate: values.departureDate,
      captcha: values.captcha,
      source: values.source,
      locale
    });
    $[0] = diyNewsletterSignup;
    $[1] = hideDepartureDate;
    $[2] = locale;
    $[3] = newsletterSignup;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onSubscribe = t1;
  let t2;
  if ($[5] !== img) {
    t2 = img?.responsiveImage && <div className={styles.imageWrap} style={{
      "--newsletter-img-ratio": img.responsiveImage.aspectRatio
    } as CSSProperties}><Image key={img.responsiveImage.src} data={img.responsiveImage} objectFit="contain" layout="fill" /></div>;
    $[5] = img;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== heading) {
    t3 = <Heading level="h3" variant="heading-md">{heading}</Heading>;
    $[7] = heading;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== description) {
    t4 = <p>{description}</p>;
    $[9] = description;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== departureDatePrompt || $[12] !== hideDepartureDate || $[13] !== onSubscribe || $[14] !== source) {
    t5 = <ReusableNewsletterForm source={source} departureDatePrompt={departureDatePrompt} hideDepartureDate={hideDepartureDate} onSubscribe={onSubscribe} />;
    $[11] = departureDatePrompt;
    $[12] = hideDepartureDate;
    $[13] = onSubscribe;
    $[14] = source;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <Box mdSpaceRight="--by-space-1200"><Stack space="--by-space-400">{t3}{t4}{t5}</Stack></Box>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t2 || $[21] !== t6) {
    t7 = <div className={styles.flushTop}><Section><div className={styles.container}>{t2}{t6}</div></Section></div>;
    $[20] = t2;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
export { ReusableNewsletterSignup };